import { ArrowUpRight, Mail, MapPin, MessageCircle, PhoneCall } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { contactPageData } from "../../data/contactData";

const quickIcons = [PhoneCall, MessageCircle, Mail, MapPin];
const accentStyles = [
  "from-royal-blue/18 via-royal-blue/8 to-transparent",
  "from-emerald-400/18 via-emerald-300/8 to-transparent",
  "from-violet-400/16 via-blue-300/8 to-transparent",
  "from-warm-gold/18 via-warm-gold/8 to-transparent"
];

function ContactQuickConnectSection() {
  const { quickConnect } = contactPageData;

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Quick Connect"
          title="Choose the Fastest Way to Start"
          description="Select the communication style that feels easiest for you and we will take it from there."
        />

        <div className="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {quickConnect.map((item, index) => {
            const Icon = quickIcons[index % quickIcons.length];
            const isExternal = /^https?:\/\//.test(item.href || "");

            return (
              <a
                key={item.title}
                href={item.href}
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noreferrer" : undefined}
                className="group signature-card signature-card-interactive relative overflow-hidden rounded-2xl p-5"
              >
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${accentStyles[index % accentStyles.length]} opacity-0 transition duration-300 group-hover:opacity-100`}
                />

                <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-glow text-royal-blue transition group-hover:bg-royal-blue group-hover:text-soft-white">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="relative mt-4 text-xl leading-tight text-midnight-navy">{item.title}</h3>
                <p className="relative mt-2 text-sm leading-relaxed text-slate-text/80">{item.text}</p>
                <span className="relative mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-royal-blue group-hover:text-midnight-navy">
                  Connect now
                  <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </MotionSection>
  );
}

export default ContactQuickConnectSection;
